module.exports = __webpack_public_path__ + "img/kyano-virtual-card.cf196f13.svg";